import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: { requiredAuth: false }
    },
    {
      path: "/",
      name: "dashboard",
      redirect: { name: "payments" },
      component: () => import("./views/Layouts/Dashboard.vue"),
      meta: { requiredAuth: true },
      children: [
        {
          path: "payments",
          name: "payments",
          component: () => import("./views/Dashboard/Payments.vue")
        },
        {
          path: "transactions",
          name: "transactions",
          component: () => import("./views/Dashboard/Transactions/Index.vue"),
          children: [
            {
              path: "index",
              name: "transactions",
              component: () =>
                import("./views/Dashboard/Transactions/Transactions.vue")
            },
            {
              path: "failed",
              name: "failed-transactions",
              component: () =>
                import("./views/Dashboard/Transactions/Failed.vue")
            },
            {
              path: "subscriptions",
              name: "subscriptions",
              component: () =>
                import("./views/Dashboard/Transactions/Subscriptions.vue")
            },
            {
              path: "uniques",
              name: "unique-transactions",
              component: () =>
                import("./views/Dashboard/Transactions/Uniques.vue")
            },
            {
              path: "charges",
              name: "charges",
              component: () =>
                import("./views/Dashboard/Transactions/Charges.vue")
            }
          ]
        },
        {
          path: "leads",
          name: 'leads',
          component: () => import("./views/Dashboard/Leads/Index.vue"),
        },
        {
          path: "downloads",
          name: "downloads",
          component: () => import("./views/Dashboard/Downloads.vue")
        }
      ]
    },
    {
      path: "/account",
      name: "account",
      redirect: { name: "profile" },
      component: () => import("./views/Layouts/Account.vue"),
      meta: { requiredAuth: true },
      children: [
        {
          path: "profile",
          name: "profile",
          component: () => import("./views/Account/Profile.vue")
        },
        {
          path: "password",
          name: "password",
          component: () => import("./views/Account/Password.vue")
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredAuth)) {
    if (Vue.auth.isAuthenticated()) {
      next();
    } else {
      next({ path: "/login" });
    }
  } else {
    if (Vue.auth.isAuthenticated() && to.fullPath === "/login") {
      next({ path: "/" });
    } else {
      next();
    }
  }
});

export default router;
